import classNames from "classnames";
import { useTranslation } from "next-i18next";

import TextField, { OutlinedTextFieldProps } from "@mui/material/TextField";

import styles from "./text-field.module.scss";
// @ts-ignore
export interface Props extends OutlinedTextFieldProps {
  children?: React.ReactNode;
  className?: string;
  variant?: string;
  title?: string;
  pattern?: string;
  required?: boolean;
}
function OurTextField(props: Readonly<Props>) {
  const {
    children,
    className,
    variant = "outlined",
    required,
    pattern,
    inputProps = {},
    ...otherProps
  } = props;

  const { t } = useTranslation();

  if (required) {
    inputProps.required = required;
  }
  if (inputProps && !inputProps?.title && inputProps.required) {
    if (pattern) {
      inputProps.title = t("Invalid format") || "Invalid format";
    } else {
      inputProps.title =
        t("Please fill in this field") || "Please fill in this field";
    }
  }

  return (
    <TextField
      className={classNames([
        styles.textfield,
        className,
        "sebkort-brand-textfield",
      ])}
      inputProps={inputProps}
      {...otherProps}
    >
      {children}
    </TextField>
  );
}

export default OurTextField;
